import { GTagEvent } from 'lib/gtag';

type Message =
  | 'LOGIN_SUCCESS'
  | 'RELOAD_AVATAR'
  | 'CLOSE_OVERLAY'
  | 'GAME_ASSET_PURCHASED'
  | { type: 'LOGIN_WITH_DETAILS'; payload: { accessToken: string; refreshToken: string } }
  | { type: 'hdkCommand'; command: string; args: unknown[] }
  | { type: 'gtagRecordEvent'; value: GTagEvent };

export const postMessageToEngine = (message: Message) => {
  window?.parent.postMessage(message, '*');
};
